import { useTranslation } from 'react-i18next';
import { Widget, WidgetProps } from '../widget';
import { useProfile } from '@/hooks';

export default function MyReferenceLink({ ...props }: WidgetProps) {
  const { t } = useTranslation();
  const { profile } = useProfile();
  // TODO: reflink
  // const refLink = location.origin + '/register?ref=' + profile?.refLink?.split('=')[1];
  const refLink = location.origin + `/register?ref=${profile.id}`;

  const handleCopy = () => {
    navigator?.clipboard?.writeText(refLink);
  };
  const handleTweet = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${refLink}`,
      'tweet',
      'menubar=1,resizable=1,width=800,height=600',
    );
  };

  return (
    <Widget title={t('My Reference Link')} loading={false} {...props}>
      <p className='dark:text-white'>
        {t('Inviting friends to Midle will grant you and your friends an enclusive point bonus!')}
      </p>

      <div
        className='w-full mt-4 p-4 flex items-center justify-between bg-blue-50 dark:bg-black/20 text-blue-600 dark:text-blue-400 rounded-lg cursor-pointer'
        onClick={handleCopy}
      >
        <p className='text-xs leading-4 font-normal md:text-base md:leading-6 md:font-normal md:ml-1'>
          <i className='icon-link' /> {refLink}
        </p>
        <i className='icon-copy' />
      </div>

      <button
        className='w-full h-8 md:h-12 flex justify-center border border-[rgba(40,170,225,1)] rounded-lg mt-4 text-xs leading-4 font-medium md:text-sm md:leading-5 md:font-medium text-[rgba(40,170,225,1)] items-center hover:brightness-75 transition-all duration-300'
        onClick={handleTweet}
      >
        {t('Share my reference link on Twitter')}
        <i className='icon-twitter ml-2' />
      </button>
    </Widget>
  );
}
